import classNames from 'classnames';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { useStorage } from '../../hooks/use-storage';
import { layoutDefaults } from '../../utils/layout-defaults';
import { parseDefaultTextColor } from '../../utils/manager/layout-manager';
import { parseOrderDescription } from '../../utils/manager/order-manager';

function OrderDescription({ className, order, isSelfOrder }) {
  const { menuLayout } = useStorage();
  const { t } = useTranslation();

  const isSingle = useMemo(() => (order.quantity ?? 1) === 1, [order.quantity]);

  const classes = useStyles({
    isSelfOrder,
    isSingle,
    layout: menuLayout,
  });

  return (
    <span className={classNames(classes.container, className)}>
      <span className={classes.quantity}>
        <b>{order.quantity}</b>x
      </span>{' '}
      {parseOrderDescription(order)}
      {order.note && (
        <>
          <span>,&nbsp;</span>
          <span className={classes.note}>
            {t('note')}: {order.note}
          </span>
        </>
      )}
    </span>
  );
}

const useStyles = createUseStyles({
  container: {
    // display: "inline",
    // border: '1px solid white',
  },
  quantity: {
    // color: ({ layout }) => parseDefaultBackgroundShade(layout, 20),
    color: ({ layout }) => parseDefaultTextColor(layout),
    backgroundColor: ({ layout }) =>
      parseDefaultTextColor(layout, layoutDefaults.smallOpacity),
    paddingTop: layoutDefaults.smallestVerticalMargin,
    paddingLeft: layoutDefaults.smallerHorizontalMargin,
    paddingRight: layoutDefaults.smallerHorizontalMargin,
    borderRadius: layoutDefaults.smallRadius,
    marginRight: layoutDefaults.smallestHorizontalMargin,
  },
  note: {
    // textDecorationLine: 'underline',
    // textUnderlinePosition: 'under',
  },
});

export { OrderDescription };
